module.exports = __webpack_public_path__ + "img/d6iuhnh-22a84a73-8669-48aa-aaac-47e886276b7c.4f42ffa0.jpg";